/** A flat progress bar (`.prog`), reused by the banner, building and close screens. */

export interface ProgressBarProps {
  /** Doors already recorded. */
  value: number;
  /** Doors in the pool this progress bar covers. */
  total: number;
  /** Accessible label, e.g. `"41 sur 68 portes renseignées"`. */
  label: string;
}

/**
 * Render a flat progress bar.
 *
 * @param props - Recorded/total counts and an accessible label.
 * @returns The progress bar element.
 */
export function ProgressBar({ value, total, label }: ProgressBarProps) {
  const percent = total > 0 ? Math.min(100, Math.round((value / total) * 100)) : 0;
  return (
    <div
      className="prog"
      role="progressbar"
      aria-valuenow={value}
      aria-valuemin={0}
      aria-valuemax={total}
      aria-label={label}
    >
      <i style={{ width: `${percent}%` }} />
    </div>
  );
}
